import React, { ReactNode } from 'react';
import LocalizedLink from 'components/LocalizedLink';
import LanguageCurrencyPopover from '../popovers/LanguageCurrencyPopover';
import classnames from 'classnames';
import { useLocation } from 'react-router-dom';

const CSS = require('./NavbarListItem.less');

interface NavbarListItemProps {
  children?: ReactNode;
  to?: any;
  transparent?: boolean;
  notificationBubble?: boolean;
  className?: string;
  externalLink?: boolean;
  isLangCurr?: boolean;
  'data-test-id'?: string;
}

function NavbarListItem({ children, to, transparent, notificationBubble, className, externalLink, isLangCurr, 'data-test-id': testId }: NavbarListItemProps) {
  const location = useLocation();

  const navbarMenuListItemClass = classnames(CSS.navbarMenuListItem, {
    [CSS['navbarMenuListItem-transparent']]: transparent, [className]: className,
    [CSS.Active]: location.pathname.indexOf(to) > -1,
  });
  
  return (
    <li className={navbarMenuListItemClass}>
      {externalLink &&
        <a className={CSS.navbarMenuListItemAnchor} href={to} target={'_blank'} rel="noopener noreferrer" data-test-id={testId}>
          {children}
          {notificationBubble && <div className={CSS.notificationBubble}/>}
        </a>
      }
      {isLangCurr &&
        <LanguageCurrencyPopover transparent={transparent} />
      }
      {(!externalLink && !isLangCurr) &&
        <LocalizedLink className={CSS.navbarMenuListItemAnchor} to={to} data-test-id={testId}>
          {children}
          {notificationBubble && <div className={CSS.notificationBubble}/>}
        </LocalizedLink>
      }
    </li>
  );
}

export default NavbarListItem;
